import React, { useEffect, useState } from "react"
import "./index.less"
import { message, Modal, Button } from "antd"
import * as API from "../../api"
import { getAuth } from "../../utils/global"
import Cookies from "js-cookie"
const AccessDenied: React.FC = (props) => {
	const [isModalVisible, setIsModalVisible] = useState(false)
	
	const jump = () => {
		//window.location.href = `${process.env.REACT_APP_LOGIN}/oauth/authorize?response_type=code&scope=read&redirect_uri=${process.env.REACT_APP_REDIRECT}&client_id=${process.env.REACT_APP_ID}&state=${process.env.REACT_APP_SECRET}`
	}

	const showApplyModal = () => {
		setIsModalVisible(true)
	}

	const handleApply = () => {
		window.open('https://wf.17usoft.com/workflow/?from_wecom=1#/myApplication/formApply?modelKey=TTAllDFQManager', '_blank')
		setIsModalVisible(false)
	}

	const handleCancel = () => {
		setIsModalVisible(false)
	}
	useEffect(() => {
		const access_token = Cookies.get("access_token")
		if (access_token) {
			API.login({ access_token })
				.then((res) => {
					// 项目登录
					const { code } = res
					if (code === 0) {
						getAuth('route')
							.then((res: any) => {
								if (res.length > 0) {
									props.history.push("/index")
								}
							})
							.catch(() => {
								message.error("获取权限失败！")
							})
						// API.getAuthority().then(res => { // 获取权限
						// 	const { code, data, msg } = res
						// 	if (code === 0) {
						// 		const { authMap, authAll } = storePermission(data)
						// 		// console.log(authAll)
						// 		if (authMap.route.length > 0) {
						// 			props.history.push('/index')
						// 		}
						// 	} else {
						// 		message.error(msg)
						// 	}
						// }).catch(() => {
						// 	message.error('获取权限失败！')
						// })
					} else {
						// message.error(msg)
						jump()
					}
				})
				.catch(() => {
					// message.error('登录失败！请刷新重试')
					jump()
				})
		} else {
			jump()
		}
	}, [])
	return (
		<div className="access-denied-wrapper">
			<img
				className="icon-lock"
				src={require("../../assets/img/icon_access_denied.png")}
				alt=""
			/>
			<h1>对不起，您暂无访问权限···</h1>
			<p>
				<span>如需访问，请点击下方按钮申请权限，或发送权限申请邮件至</span>
				<span className="hl">dong3.yan@ly.com</span>
			</p>
			<div style={{ margin: '20px 0' }}>
				<Button type="primary" size="large" onClick={showApplyModal}>
					申请权限
				</Button>
			</div>
			<img
				className="logo"
				src={require("../../assets/img/logo_tcyl.png")}
				alt=""
			/>

			<Modal
				title="权限申请"
				open={isModalVisible}
				onOk={handleApply}
				onCancel={handleCancel}
				okText="前往申请"
				cancelText="取消"
			>
				<p>您即将跳转到权限申请页面，请按照流程提交申请。</p>
				<p>申请提交后，请耐心等待审批结果。</p>
			</Modal>
		</div>
	)
}

export default AccessDenied
